import { CLASS_NAME as FORUM_TYPE } from 'hb-react/backoffice/apps/Forum/constants';

interface ConfigUrlsProps {
  availableForNetwork?: boolean;
  hasPagination?: boolean;
  ids?: Array<number>;
  networkId: number;
  page?: number;
  perPage?: number;
  searchKeyword?: string;
  topicId?: number;
  type: string;
}

const getPath = ({
  hasPagination,
  networkId,
  page,
  perPage,
  searchKeyword,
  ids,
  topicId,
  type,
  availableForNetwork,
}: ConfigUrlsProps) => {
  const withPaginationOptions = ids
    ? {
        ids,
      }
    : searchKeyword
      ? {
          query: searchKeyword,
        }
      : {
          order_by: 'updated_at',
          order: 'desc',
        };

  const commonOption = hasPagination
    ? {
        per_page: perPage,
        page,
        ...withPaginationOptions,
      }
    : {};

  const options = topicId
    ? { topic_id: topicId, ...commonOption }
    : commonOption;

  if (type === FORUM_TYPE) {
    return () =>
      Routes.backoffice_network_forums_network_categories_path(networkId, {
        network_category: {
          categorized_type: type,
          ...(availableForNetwork
            ? { available_for_network: availableForNetwork }
            : {}),
        },
        ...options,
      });
  }

  return () =>
    Routes.backoffice_network_network_categories_path(networkId, {
      network_category: {
        categorized_type: type,
        ...(availableForNetwork
          ? { available_for_network: availableForNetwork }
          : {}),
      },
      format: 'json',
      ...options,
    });
};

const positionPath = ({ type, topicId, networkId }: ConfigUrlsProps) => {
  const options = topicId ? { topic_id: topicId } : {};

  if (type === FORUM_TYPE) {
    return (categoryId: number) =>
      Routes.backoffice_network_forums_network_category_path(
        networkId,
        categoryId,
        options,
      );
  }

  return (categoryId: number) =>
    Routes.backoffice_network_network_category_path(
      networkId,
      categoryId,
      options,
    );
};

const createPath = ({ type, topicId, networkId }: ConfigUrlsProps) => {
  const options = topicId ? { topic_id: topicId } : {};

  if (type === FORUM_TYPE) {
    return () =>
      Routes.backoffice_network_forums_network_categories_path(
        networkId,
        options,
      );
  }

  return () =>
    Routes.backoffice_network_network_categories_path(networkId, options);
};

const updatePath = ({ type, topicId, networkId }: ConfigUrlsProps) => {
  const options = topicId ? { topic_id: topicId } : {};

  if (type === FORUM_TYPE) {
    return (categoryId: number) =>
      Routes.backoffice_network_forums_network_category_path(
        networkId,
        categoryId,
        options,
      );
  }

  return (categoryId: number) =>
    Routes.backoffice_network_network_category_path(
      networkId,
      categoryId,
      options,
    );
};

const deletePath = ({ type, topicId, networkId }: ConfigUrlsProps) => {
  const options = topicId ? { topic_id: topicId } : {};

  if (type === FORUM_TYPE) {
    return (categoryId: number) =>
      Routes.backoffice_network_forums_network_category_path(
        networkId,
        categoryId,
        {
          no_redirect: true,
          ...options,
        },
      );
  }

  return (categoryId: number) =>
    Routes.backoffice_network_network_category_path(networkId, categoryId, {
      no_redirect: true,
      ...options,
    });
};

export const makeConfigUrls = (props: ConfigUrlsProps) => ({
  getCategoriesPath: getPath({ ...props }),
  savePositionPath: positionPath({ ...props }),
  deleteCategoryPath: deletePath({ ...props }),
  updateCategoryPath: updatePath({ ...props }),
  createCategoryPath: createPath({ ...props }),
});
